import { render, staticRenderFns } from "./SubscriptionExpiry.vue?vue&type=template&id=59668caa&scoped=true&"
import script from "./SubscriptionExpiry.vue?vue&type=script&lang=js&"
export * from "./SubscriptionExpiry.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionExpiry.vue?vue&type=style&index=0&id=59668caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59668caa",
  null
  
)

export default component.exports